import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef, Output, EventEmitter, Inject
} from '@angular/core';
import {isEmpty, get, sortBy, merge} from 'lodash';
import {Subject} from 'rxjs/Subject';
import {IcodeDisplay, Ifacillity} from '@ispm-client/modules/aggregator/interfaces/index';
import {AgregationService} from '@ispm-client/modules/aggregator/services';
import {ITEMS_TYPES} from "@ispm/dynamic-form/constants/ItemsTypes";
import {DynamicFormItem} from "@ispm/dynamic-form/classes/dynamic-form-item.class";
import { distinctUntilChanged,takeUntil} from "rxjs/operators";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
  selector: 'gen-facility-filter',
  templateUrl: './facility-filter.component.html',
  styleUrls: ['./facility-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacilityFilterComponent implements OnInit {

  private destroyed$: Subject<any> = new Subject();
  public loading: boolean;
  public isFacilityEnabled: boolean = false;
  public defaultAssociation: boolean = undefined;

  private currentAssociatedActiveFacilities: Array<Ifacillity>;
  public formData: any = {};
  private recievedData: any = {};
  private allFacility :any  = {code: 'all', display: 'All My Facilities'};
  public formChanged: boolean = false;
  public formConfig: DynamicFormItem[] = [];
  @Output() onFacilityApply : EventEmitter<any> = new EventEmitter();

  constructor(private _changeDetector: ChangeDetectorRef,
              private notificationMessageService: NotificationMessageService,
              private _aggregatorService: AgregationService) {
  }

  ngOnInit() {
    this._aggregatorService.getSelectedFacilities().filter(alldata => !isEmpty(alldata)).takeUntil(this.destroyed$).subscribe((data) => {
      if(!isEmpty(data['selectedFacilities'])) {
        this.defaultAssociation = (get(data, 'association') == 'managedByFacility') ? false : true;
        if (this.recievedData['association'] === this.defaultAssociation) {
          return;
        }

        this.recievedData['association'] = this.defaultAssociation;
        const currentFacility = get(data, 'selectedFacilities');
        this.recievedData['selectedFacilities'] = Object.assign({}, currentFacility[0]);
        this.formData['selectedFacilities'] = this._aggregatorService.keysRenaming(currentFacility[0], {
          id: 'code',
          name: 'display'
        });
        this.formData['association'] = this.defaultAssociation;
        this.buildFacilitySelection();
        this.treeShaking();
      }
    });

    this._aggregatorService.getDefaultWorklistFilter().pipe(takeUntil(this.destroyed$.asObservable()),distinctUntilChanged()).filter(x => x !== undefined).subscribe((selection) =>{
      const defaultAssociation =  (selection == 'managedByFacility') ? false:true;
      if(this.defaultAssociation == undefined) {
        this.defaultAssociation = defaultAssociation;
      }
      if(this.recievedData['association'] === this.defaultAssociation) {
        return;
      }
      else if(!isEmpty(this.recievedData['selectedFacilities'])){
        return;
      }

      this.recievedData['association'] = this.defaultAssociation;
      this.recievedData['selectedFacilities'] = Object.assign({}, this.allFacility);
      this.updateDataToStore(true);
    });
    this._aggregatorService.getFacilities().pipe(takeUntil(this.destroyed$.asObservable())).subscribe((data) => {
      this.isFacilityEnabled = get(data, 'isFacilityEnabled');
      const currentAssociatedActiveFacilities = get(data, 'currentAssociatedActiveFacilities');
      this.currentAssociatedActiveFacilities =  sortBy(currentAssociatedActiveFacilities,
        [function(o) { return o.name; }]);
      this.buildFacilitySelection();
      this.treeShaking();

    });


  }

  buildFacilitySelection() {


    const options: Array<IcodeDisplay> = [Object.assign({},this.allFacility),...this._aggregatorService.keysRenaming(this.currentAssociatedActiveFacilities, {
      id: 'code',
      name: 'display'
    })];

    const defaultValue = this.formData['selectedFacilities'] ? this.formData['selectedFacilities'] : Object.assign({},this.allFacility);
    this.formData['selectedFacilities'] = defaultValue;
    this.formConfig = [DynamicFormItem.builder('', 'selectedFacilities', ITEMS_TYPES.DROPDOWN)
      .setOptions(options)
      .setDefault(defaultValue)
      .setPlaceholder('Select Facility')
      .setCssClass(' full-size-item no-margin-right')
      .setAttributes({'[hideInvalidTooltip]': true, '[forceFormMode]': true})
    ];
  }

  public updateFormData(formData: any): void {
      this.recievedData = merge(this.formData, formData);
      this.formChanged = true;
  }

  public updateSelection(selection: boolean): void {
    this.recievedData['association'] = selection;
    this.formChanged = true;
  }




  public updateDataToStore(noEmit:boolean = false): void {
    let selectedFacility = get(this.recievedData, 'selectedFacilities');
    //managedByFacility:false|associatedFacility:true
    const association: string = this.recievedData.association ? 'associatedFacility' : 'managedByFacility';
    if (selectedFacility) {
      this._aggregatorService.updateFacilities([this._aggregatorService.keysRenaming(this.recievedData['selectedFacilities'], {
        code: 'id',
        display: 'name'
      })], association,!noEmit);
      this.formChanged = false;
      if(!noEmit) {
        this.onFacilityApply.emit(true);
      }
    } else {
      this.notificationMessageService.warning('Facility value is invalid');
    }
  }


  private treeShaking(){
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }
  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
